<template>
	<div class="PaymentMethodPix w-100 py-3 bg-gray">
		<div class="row mb-4">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<span class="bx-resumo-title">Resumo do pedido:</span>	
				<ul class="resumo-pedido">
					<li class="py-2">
						<label class="field">Nº do Pedido:</label>
						<label>{{boleto.order}}</label>
					</li>
					<li class="py-2">
						<label class="field">Vencimento:</label>
						<label>{{$helper.formatDateMMDDYYYY(pix.expiration_date)}}</label>
					</li>
					<li class="py-2">
						<label class="field">Valor:</label>
						<label>
							<b>R$ {{$helper.formatValue(boleto.valor)}}</b>
						</label>
					</li>
					<template v-if="expanded">
						<li class="py-2 noprint">
							<label class="field">Produto:</label>
							<label>{{boleto.produto}}</label>
						</li>
						<li class="py-2 noprint">
							<label class="field">Nome:</label>
							<label>{{boleto.cliente_nome}}</label>
						</li>
						<li class="py-2 noprint">
							<label class="field">E-mail:</label>
							<label>{{boleto.cliente_email}}</label>
						</li>
						<template v-if="isCnpj">
							<li class="py-2 noprint">
								<label class="field">CPF/CNPJ:</label>
								<label>{{boleto.cliente_cpfcnpj | taxid_display}}</label>
							</li>
							<li class="py-2 noprint">
								<label class="field">Endereço:</label>
								<label>
									<span>{{boleto.cliente_endereco}}</span>
									<span v-if="boleto.cliente_cep != ''"> - {{boleto.cliente_cep}}</span>
									<span> - {{boleto.cliente_cidade}}/{{boleto.cliente_estado}}</span>
								</label>
							</li>
						</template>
					</template>
					<button class="expand-btn noprint" :class="{ 'expanded': expanded }" @click="expandFields()">
						<inline-svg :src="require(expanded ? '@/assets/img/pbi/pbi_seta_simples_para_cima_12.svg' : '@/assets/img/pbi/pbi_seta_simples_para_baixo_12.svg')" />
					</button>
				</ul>
			</div>
		</div>
		<div class="row mb-4" v-if="pix.pix_img">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<span class="bx-resumo-title noprint">Instruções para pagamento:</span>
				<ul class="resumo-pedido">
					<li class="pix-title">
						Pague com o <b>QR Code</b> abaixo:
					</li>
					<li class="text-center">
						<img :src="pix.pix_img">
					</li>
					<li class="copy noprint">
						<button ref="button" aria-describedby="tooltip" class="copy-btn" @click="copyToClipboard(pix.pix_code)">
							<inline-svg :src="require('@/assets/img/pbi/pbi_copy_24.svg')" />
							<span>PIX COPIA E COLA</span>
						</button>
						<div ref="tooltip" class="tooltip hide_tooltip noprint" role="tooltip">
							Copiado! 
							<div ref="arrow" class="arrow"></div>
						</div>
					</li>
					<li class="pix-confirmation-text noprint">
						<span>Seu pagamento será confirmado automaticamente.</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

import InlineSvg from "vue-inline-svg"
import {
	computePosition,
	flip,
	offset,
	arrow
} from "@floating-ui/dom";

export default {
	name: 'PaymentMethodPix',
	data(){
		return{
			payload: {},
			pix_img: '',
			pix_code: '',
			payment_id: '',
			expanded: false,
		}
	},

	components: {
		InlineSvg
	},

	mounted: function(){},

	computed: {
		boleto(){
			return this.$store.state.boleto.boleto;
		},

		pix(){
			return this.$store.state.boleto.pix;
		},

		isCnpj(){
			return this.boleto.cliente_cpfcnpj.length > 11
		}
	},

	methods: {
		copyToClipboard(value){
			this.$helper.copyToClipboard(value);

			const tooltip = this.$refs.tooltip;
			tooltip.classList.remove('hide_tooltip');
			tooltip.classList.add('show_tooltip');

			this.renderTooltip();

			setTimeout(() => {
				tooltip.classList.remove('show_tooltip');
				tooltip.classList.add('hide_tooltip');
			}, 2000);
		},

		renderTooltip(){
			const button	= this.$refs.button;
			const tooltip	= this.$refs.tooltip;
			const arrowEl	= this.$refs.arrow;
		
			computePosition(button, tooltip, {
				placement: 'bottom',
				middleware: [offset(6), flip(), arrow({ element: arrowEl })],
			}).then(({x, y, placement, middlewareData}) => {
				Object.assign(tooltip.style, {
					left: `${x}px`,
					top: `${y}px`,
				});

				const {x: arrowX, y: arrowY} = middlewareData.arrow;

				const staticSide = {
					top: 'bottom',
					right: 'left',
					bottom: 'top',
					left: 'right',
				}[placement.split('-')[0]];

				Object.assign(arrowEl.style, {
					left: arrowX != null ? `${arrowX}px` : '',
					top: arrowY != null ? `${arrowY}px` : '',
					right: '',
					bottom: '',
					[staticSide]: '-8px',
				});
			});
		},

		expandFields(){
			this.expanded = !this.expanded;
		}
	},

	filters: {
		taxid_display: function(value) {
			let taxid = (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
			let returnValue = '';
			
			if (taxid.length > 11) {
				returnValue = taxid.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/g, "$1.$2.$3/$4-$5");
			} else {
				returnValue = taxid.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
			}
			
			return returnValue;
		},
	},
}
</script>